import { Component, OnInit } from "@angular/core";
import { EcommerceService } from "../service/ecommerce.service";

@Component({
    selector : 'app-home',
    templateUrl : './home.component.html',
    styleUrls : ['./home.component.css']
})

export class HomeComponent implements OnInit {
    productLength: any;
    cartDatas = [];
    loaderFinal : any;
    constructor(private ecommerceService: EcommerceService) { }
 
    ngOnInit() {
        this.cartData();
    }
 
    cartData() {
        this.cartDatas = this.ecommerceService.showToCard();
        this.productLength = this.cartDatas.length;
        console.log('rafeeq', this.cartDatas);
     }
  

}